import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["styleConfig"],
  _excluded2 = ["baseConfig"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useChakra } from "./chunk-7V3ZYTH7.mjs";

// src/use-style-config.ts
import { resolveStyleConfig } from "@chakra-ui/styled-system";
import { mergeThemeOverride } from "@chakra-ui/theme-utils";
import { filterUndefined, memoizedGet as get, mergeWith, omit } from "@chakra-ui/utils";
import { useRef } from "react";
import isEqual from "react-fast-compare";
function useStyleConfigImpl(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a;
  var styleConfigProp = props.styleConfig,
    rest = _objectWithoutProperties(props, _excluded);
  var _useChakra = useChakra(),
    theme = _useChakra.theme,
    colorMode = _useChakra.colorMode;
  var themeStyleConfig = themeKey ? get(theme, "components.".concat(themeKey)) : void 0;
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = mergeWith({
    theme: theme,
    colorMode: colorMode
  }, (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {}, filterUndefined(omit(rest, ["children"])));
  var stylesRef = useRef({});
  if (styleConfig) {
    var getStyles = resolveStyleConfig(styleConfig);
    var styles = getStyles(mergedProps);
    var isStyleEqual = isEqual(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
}
function useComponentStyles__unstable(themeKey, props) {
  var _a;
  var baseConfig = props.baseConfig,
    restProps = _objectWithoutProperties(props, _excluded2);
  var _useChakra2 = useChakra(),
    theme = _useChakra2.theme;
  var overrides = (_a = theme.components) == null ? void 0 : _a[themeKey];
  var styleConfig = overrides ? mergeThemeOverride(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, _objectSpread(_objectSpread({}, restProps), {}, {
    styleConfig: styleConfig
  }));
}
export { useStyleConfig, useMultiStyleConfig, useComponentStyles__unstable };